import { render, staticRenderFns } from "./welcome-expansion-panel-header.vue?vue&type=template&id=504c1dfa&scoped=true&"
import script from "./welcome-expansion-panel-header.vue?vue&type=script&lang=js&"
export * from "./welcome-expansion-panel-header.vue?vue&type=script&lang=js&"
import style0 from "./welcome-expansion-panel-header.vue?vue&type=style&index=0&id=504c1dfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c1dfa",
  null
  
)

export default component.exports